import { Fragment } from 'react';

import { EntityRefLink } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';
import { Entity } from '@backstage/catalog-model';

export const UsageCard = (props: { entities: Entity[]; title: string }) => {
  const { entities, title } = props;
  return (
    <InfoCard title={title}>
      {entities.map((entity, i) => (
        <Fragment key={entity.metadata.name}>
          {i > 0 && ', '}
          <EntityRefLink
            entityRef={entity}
            defaultKind="component"
            title={entity.metadata.title}
          />
        </Fragment>
      ))}
    </InfoCard>
  );
};
